import React from 'react';
import { FormattedMessage } from 'react-intl';
import PrevSearchButton from '../SearchBar/PrevSearchButton';

function UMONoItemFound({ isSearchEmpty, welcomeMessage }) {
  let displayMessage = <div></div>;
  if (isSearchEmpty) {
    displayMessage = 
    (welcomeMessage ? <div className='umo-empty-placeholder__welcome-message'>
        <div className='umo-empty-placeholder__msg-title'>
          {welcomeMessage?.title}
        </div>
        <div className='umo-empty-placeholder__msg-subtitle'>
          {welcomeMessage?.subtitle}
        </div>
    </div> : <></>);
  } else {
    displayMessage = (<div>
      <div className='umo-empty-placeholder__bg' />
    <div className='umo-empty-placeholder__title'>
      <FormattedMessage id="searchResults.noItemFound" description="No Item Found"  />
    </div>
    <div className='umo-empty-placeholder__back'>
      <PrevSearchButton />
    </div>
    </div>);
  }
  return (
    <div className='umo-empty-placeholder'>
      {displayMessage}
    </div>
  );
}

export default UMONoItemFound;